import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { OpenedPagePayload } from './interfaces/opened-page-payload.interface';
import { isNonNullObject } from 'utilities';

export const OpenedPageMessage: MessageHandler<OpenedPagePayload> = {
  send(payload: OpenedPagePayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.OpenedPage, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is OpenedPagePayload {
    if (!isNonNullObject(payload)) return false;
    const page = (payload as Record<string, unknown>)['page'];
    return typeof page === 'string' && page.trim().length > 0;
  },
};
